"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var utils_1 = require("./../utils");
var TreeOrigin_1 = __importDefault(require("./TreeOrigin"));
function Tree(props) {
    var data = props.data, onCallback = props.onCallback, style = props.style, className = props.className, titleText = props.titleText, clearText = props.clearText, _a = props.showText, showText = _a === void 0 ? 'Show All' : _a, _b = props.showLessText, showLessText = _b === void 0 ? 'Show Less' : _b;
    var wideData = (0, utils_1.deepCopy)(data);
    return Array.isArray(wideData) && wideData.length ? (react_1.default.createElement(TreeOrigin_1.default, { data: wideData, onCallback: onCallback, style: style, className: className, titleText: titleText, clearText: clearText, showText: showText, showLessText: showLessText })) : null;
}
exports.default = Tree;
//# sourceMappingURL=Tree.js.map